// extracted by mini-css-extract-plugin
export var button = "_k0-0";
export var donut = "_k0-1";
export var donutFill = "_k0-3";
export var donutTrack = "_k0-2";